import { z } from 'zod';

/** One filter-dropdown option. All three Reports dropdowns reuse products-admin meta endpoints,
 *  which return `{ id, name }` — identical to the shipped `replacementOptionSchema`. */
export const reportOptionSchema = z.object({ id: z.string(), name: z.string() });

/** One cursor-paginated page of options. Verified against `greenway_api@develop`'s
 *  `PRODUCT_META_RESPONSE_EXAMPLE`. The report **grids** are offset-paged; these dropdowns are
 *  cursor-paged, and the two shapes are not interchangeable. */
export const reportOptionPageSchema = z.object({
  data: z.array(reportOptionSchema),
  meta: z.object({ nextCursor: z.string().optional(), hasNextPage: z.boolean() }),
});
